// this is an autogenerated file from DesignSystem/PreviewDocumentModal/Content/Content/PdfFile/Footer/Signature/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__DesignSystem_PreviewDocumentModal_Content_Content_PdfFile_Footer_Signature($id: numeric!) {
  documents_signature_requests(
    where: {
      status: { _eq: signed }
      resource_metadata: {
        _contains: { id: $id, table: "document_tree_nodes", schema: "vaxiom" }
      }
    }
  ) {
    id
    signed_at
    signatory_person {
      id
      first_name
      last_name
    }
  }
}

`